import React from "react"
import { Spinner, Modal, Button } from "react-bootstrap";
import { Link } from "react-router-dom"
import NotFound from "../common/NotFound";
import * as Constants from "../partials/CommonConstant"
import projectApp from "../Shared/Controller/projectApp";
import DataTable from "react-data-table-component";
import { connect } from "react-redux";
import { ShowToast, getFormattedDate } from "../common/CommonController";
import ProjectServices from "../Shared/Services/ProjectServices";

class ImportLogs extends projectApp {
  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      importLogsList: [],
      page: 1,
      perPage: 20,
      totalRows: 0,
      sortBy: "created_at",
      sortOrder: "desc",      
      searchText: "",
      messageModal: { show: false, message: "" },
    }
  }

  componentDidMount = () => {
    this.getImportLogs();
  }

  getImportLogs = () => {
    if (this.state.importLogsList.length === 0) {
      this.setState({ loading: true })
    }

    const { page, perPage, sortBy, sortOrder, searchText } = this.state;

    const params = {
      page,
      per_page: perPage,
      search: searchText,
      sort_by: sortBy,
      sort_order: sortOrder,
    };

    ProjectServices.getImportLogs(params).then((response) => {
      if (response.data.code === 1) {
        if (response.data.data) {
          this.setState({ 
            importLogsList: response.data.data.data || [],
            totalRows: response.data.data.pagination?.total || 0,
          });
        }
        else {
          this.setState({ importLogsList: [] })
        }
      } 
      else {
        if (response.data.message.constructor === Object) {
          ShowToast("object", "error", response.data.message)
        }
        else {
          ShowToast("message", "error", response.data.message)
        }
      }
      this.setState({ loading: false });
    }).catch(error => {
      ShowToast("message", "error", "" + error);
      this.setState({ loading: false });
    });
  }

  handlePageChange = (page) => {
    this.setState({ page }, this.getImportLogs);
  };

  handlePerRowsChange = (newPerPage, page) => {
    this.setState({ perPage: newPerPage, page }, this.getImportLogs);
  };

  handleSort = (column, sortDirection) => {
    this.setState(
      {
        sortBy: column.sortField,
        sortOrder: sortDirection,
      },
      this.getImportLogs
    );
  };

  getFormattedStatus = (status) => {
    if (status === "pass") {
      return <span style={{ color: "#28a745", fontWeight: "bold" }}>Pass</span>;
    }
    if (status === "fail") {
      return <span style={{ color: "#dc3545", fontWeight: "bold" }}>Fail</span>;
    }
    return status;
  }

  // toggleTooltip = (id) => {
  //   this.setState(prevState => ({
  //     activeTooltip: prevState.activeTooltip === id ? null : id
  //   }));
  // }

  // closeTooltip = () => {
  //   this.setState({ activeTooltip: null });
  // }

  // open message modal
  openMessageModal = (message) => {
    this.setState({ messageModal: { show: true, message: message || "" } });
  }

  // close message modal
  closeMessageModal = () => {
    this.setState({ messageModal: { show: false, message: "" } });
  }

  getTableColumns = () => {
    const table_columns = [
      {
        name: "Project Name",
        selector: row => row.project_name,
        wrap: true,
        width: "21%",
        sortable: true,
        sortField: "project_name",
        cell: d => { return d.project_name || "-" }
      },
      // {
      //   name: "Identifier",
      //   selector: row => row.project_identifier,
      //   width: "12%",
      //   wrap: true,
      //   sortable: true,
      //   cell: d => { return d.project_identifier || "-" }
      // },
      {
        name: "Original Filename",
        selector: row => row.original_filename,
        width: "23%",
        wrap: true,
        sortable: true,
        sortField: "original_filename"
      },
      {
        name: "Created By",
        selector: row => row.created_user,
        width: "18%",
        wrap: true,
        sortable: true,
        sortField: "created_user"
      },
      {
        name: "Status",
        selector: row => row.status,
        width: "10%",
        center: true,
        sortable: true,
        sortField: "status",
        cell: d => { return this.getFormattedStatus(d.status) }
      },
      {
        name: "Created At",
        selector: row => row.created_at,
        width: "15%",
        wrap: true,
        cell: d => { return getFormattedDate(d.created_at) },
        sortable: true,
        sortField: "created_at"
      },
      {
        name: "Message",
        selector: row => row.message,
        width: "8%",
        center: true,
        sortable: false,
        cell: d => { 
          //const isActive = this.state.activeTooltip === d.id;
          return (
            <div style={{ position: "relative" }}>
              <span                 
                onClick={(e) => {
                  e.stopPropagation();
                  this.openMessageModal(d.message);
                }}
                style={{ 
                  cursor: "pointer",
                  fontSize: "18px",
                  color: "#007bff"
                }}
              >
                ℹ️
              </span>
            </div>
          )
        }
      }
    ];
    return table_columns;
  }

  render() {
    const {      
      loading,
      page,
      perPage,
      totalRows,
      searchText,
    } = this.state;

    const data = this.state.importLogsList ? this.state.importLogsList : [];
    const columns = this.getTableColumns();

    return (
      <>
        {/* Message Modal */}
        <Modal show={this.state.messageModal.show} onHide={this.closeMessageModal} centered>
          <Modal.Header closeButton>
            <Modal.Title>Message</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div style={{ whiteSpace: "pre-wrap", wordBreak: "break-word", padding: "12px 12px 12px 12px" }}>
              {this.state.messageModal.message || "-"}
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button className="btn btn-blue" onClick={this.closeMessageModal}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>

        <div className="dashboard-card-wrapper">
          <div className="row align-items-center">
            <div className="col-6">
              <h2 className="page-title">Logs</h2>
            </div>
            <div className="col-6 text-end">
              <Link to={Constants.projectList} className="btn btn-blue btn-nex me-2">Back</Link>
            </div>
          </div>
          <div className="col-md-12 col-sm-12 col-lg-12 mt-3">
            <div className="card-main p-0">
              <div className="dark-table-wrapper table-scroll proj_table">

                {/* Custom Search Input */}
                <div className="data-table-extensions d-flex align-items-center">
                  <div className="data-table-extensions-filter position-relative">
                    <label htmlFor="filterDataTable" className="icon"></label>                        
                    <input
                      type="text"
                      name="filterDataTable"
                      className="filter-text w-100"
                      placeholder="Search"
                      value={searchText}
                      onChange={(e) => this.setState({ searchText: e.target.value })}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          this.setState({ page: 1 }, this.getImportLogs);
                        }
                      }}                       
                    />
                    
                    {searchText && (
                      <span
                        className="clear-icon"
                        onClick={() => {
                          this.setState({ searchText: "", page: 1 }, this.getImportLogs);
                        }}
                        style={{
                          position: "absolute",
                          right: "13px",
                          top: "50%",
                          transform: "translateY(-50%)",
                          cursor: "pointer",
                          fontSize: "23px",
                          color: "#545454"
                        }}
                        title="Clear search"
                      >
                      ×
                      </span>
                    )}
                  </div>
                  
                  <button
                    className="ms-2"
                    title="Click to Search"
                    disabled={searchText.trim() === ""}
                    style={{
                      backgroundColor: searchText.trim() === "" ? "#f4a75f" : "#ee7608",
                      color: "white",
                      border: "none",
                      padding: "8px 12px",
                      borderRadius: "50px",
                      cursor: searchText.trim() === "" ? "default" : "pointer"
                    }}
                    onClick={() => {
                      this.setState({ page: 1 }, this.getImportLogs);
                    }}
                  >
                    Search
                  </button>
                </div>

                {this.state.importLogsList.length !== 0 && this.state.loading === false &&
                  <DataTable
                    columns={columns}
                    data={data}
                    noHeader
                    defaultSortField="created_at"
                    defaultSortAsc={false}
                    highlightOnHover
                    onChangePage={this.handlePageChange}
                    onChangeRowsPerPage={this.handlePerRowsChange}
                    onSort={this.handleSort}
                    pointerOnHover
                    pagination
                    paginationServer
                    paginationTotalRows={totalRows}
                    paginationPerPage={perPage}
                    paginationDefaultPage={page}
                    paginationRowsPerPageOptions={[10, 20, 30, 100, 500]}
                    progressPending={loading}                    
                    sortServer
                  />
                }
                
                {this.state.loading === true &&
                  <table className="mb-0 table">
                    <tbody>
                      <tr>
                        <td colSpan={7} className="text-center">
                          <Spinner animation="border" role="status">
                            <span className="visually-hidden">Loading...</span>
                          </Spinner>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                }
                
                {this.state.loading === false && this.state.importLogsList.length === 0 &&
                  <NotFound message="No Data Found" type="content" />
                }
              </div>
            </div>
          </div>
        </div>
      </>
    )
  }
}

export default connect(projectApp.mapStateToProps, projectApp.mapDispatchToProps)(ImportLogs)
